import { Box } from "@mui/material";
import { CustomStyles, getStyles } from "src/styles/theme";
import defaultStyles, { StylesClasses } from "./styles";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";

type StatsCardProps = {
  title: string;
  value: number | string;
  variant?: "horizontal" | "vertical";
  icon?: string;
  area?: string;
  customStyles?: CustomStyles<StylesClasses>;
  onClick?: (id: string) => void;
  id: string;
};

const ACCENT = "#1F6E4E";

const fmt = (value: number | string) => {
  const num = Number(value);
  return Number.isFinite(num)
    ? num.toLocaleString("en-IN", { maximumFractionDigits: 2 })
    : String(value);
};

const ProgressCard = ({
  customStyles,
  title,
  value,
  area,
  onClick,
  id,
}: StatsCardProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);

  return (
    <Box
      {...styles("valueCard", {
        backgroundColor: `${ACCENT}0F`,
        borderColor: `${ACCENT}2E`,
        ":hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 8px 20px ${ACCENT}30`,
          borderColor: `${ACCENT}66`,
        },
      })}
      onClick={() => onClick?.(id)}
      role="button"
      tabIndex={0}
    >
      <Box {...styles("topRow")}>
        <Box {...styles("iconChip", { backgroundColor: `${ACCENT}18` })}>
          <TrendingUpOutlinedIcon sx={{ fontSize: "18px", color: ACCENT }} />
        </Box>
        <Box {...styles("title")}>{title}</Box>
      </Box>

      <Box {...styles("metrics")}>
        {area && (
          <Box>
            <Box {...styles("bigValue")}>{fmt(area)}</Box>
            <Box {...styles("metricLabel")}>Physical Progress</Box>
          </Box>
        )}
        <Box>
          <Box {...styles("bigValue")}>{fmt(value)}</Box>
          <Box {...styles("metricLabel")}>Financial Progress</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ProgressCard;
